import { render, staticRenderFns } from "./CriarToken.vue?vue&type=template&id=4c81c262&"
import script from "./CriarToken.vue?vue&type=script&lang=js&"
export * from "./CriarToken.vue?vue&type=script&lang=js&"
import style0 from "./CriarToken.vue?vue&type=style&index=0&id=4c81c262&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports